import { getCloudinaryUrl } from "@swiggy-private/js-utils";

export const BILL_PAYMENT_CONSTANTS = {
    TITLE: "Have you got the final bill from the server?",
    DESCRIPTION: "Please take the bill from the server to ensure you are paying the correct amount",
    IMAGE_ALT: "Bill Payment",
    ICON_SIZE: 102,
    SECONDARY_BUTTON_TEXT: "No",
    PRIMARY_BUTTON_TEXT: "Yes, pay now",
};

export const IMAGES = {
    BILL_PAYMENT: getCloudinaryUrl("portal/static-assets/images/dineout/qr/Pay_Bill.png") || "",
};

export const STYLED_CONSTANTS = {
    BUTTON_CONTAINER_PADDING_BOTTOM: "28px",
    HEADING_TITLE_CONTAINER_WIDTH: "294px",
    DESCRIPTION_CONTAINER_WIDTH: "330px",
};
